export enum ENUM__user_role {
  ADMIN = 'admin',
  USER = 'user',
  GUEST = 'guest',
}
